import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function StackedCardsIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="14" height="15" viewBox="0 0 14 15" fill="none" {...props}>
      <svg xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.886719 8.10677H11.3867M4.71922 10.4401H3.22005M9.63672 13.9401H2.63672C1.67014 13.9401 0.886719 13.1567 0.886719 12.1901V7.52344C0.886719 6.55685 1.67014 5.77344 2.63672 5.77344H9.63672C10.6033 5.77344 11.3867 6.55685 11.3867 7.52344V12.1901C11.3867 13.1567 10.6033 13.9401 9.63672 13.9401Z"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9189 9.54745C12.8592 9.32363 13.4399 8.3801 13.2161 7.43979L12.1355 2.89996C11.9116 1.95964 10.9681 1.37893 10.0278 1.60275L3.21806 3.22368C2.27775 3.4475 1.69703 4.39103 1.92086 5.33134"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
